import { action, observable } from "mobx";
import { inject, observer } from "mobx-react";
import * as React from "react";
import * as DocumentManagement from "../DocumentManagement";
import { Toolbar } from "../General/Toolbar";
import { TypeAheadSearchInput } from "../General/TypeAheadSearchInput";
import { DialogStore } from "../Stores/DialogStore";
import { DocumentStoreImpl } from "../Stores/DocumentStore";
import { Strings } from "../Stores/StringsStore";




interface IPrivilegesSelectionProps {
	documentID: string;
	collectionID: string;
	documentStore?: DocumentStoreImpl;
}

/**
 * component for privilege selection
 */
@inject('documentStore')
@observer
export class DocumentPrivilegeSelection extends React.Component<IPrivilegesSelectionProps, {}> {
	/** 
	*Stores  privileges for a collection
	*/
	@observable privilegesForGroups: DocumentManagement.PrivilegesForGroup[] = [];
	@observable searchTerm: string = "";
	searchTimeoutHandle: number;
	/** 
	* Stores selected privileges temporarily */
	@observable selectedPrivilege: DocumentManagement.PrivilegesForGroup[] = [];
	/**
	*keep it for lazy loading afetr getUnassignedPrivileges API Success
	*/
	@observable removedPrivilegesForGroups: DocumentManagement.PrivilegesForGroup[] = [];

	componentWillMount() {
		this.props.documentStore.saveSelectedPrivilege = this.handleSaveSelectedPrivilege;
		this.props.documentStore.addedPrivileges.map((privilege) => {
			this.selectedPrivilege.push(privilege);
		});
	}

	/* invoke when a user clicks WizardBox confirmation YES Button. it adds selected privilege from temp `selectedPrivilege` to  observable array `selectedPrivilege`( a collection store object) for further updations.*/
	@action handleSaveSelectedPrivilege = () => {
		this.props.documentStore.addedPrivileges = [];
		this.selectedPrivilege.map((privilege) => {
			if (this.props.documentStore.removedDocumentPrivileges.some(p => p.groupId !== privilege.groupId)) {
				this.props.documentStore.model.privileges.privilegesForGroups.push(privilege);
				this.props.documentStore.removedDocumentPrivileges = this.props.documentStore.removedDocumentPrivileges.filter(p => p.groupId !== privilege.groupId);
			}
			else {
				this.props.documentStore.addedPrivileges.push(privilege);
			}
		});
	}

	/* invoke when a user clicks any one  of the listed privilege. it adds selected privilege to temp observable array `selectedPrivilege` */
	onSelectionPrivilege = (selectedPrivilege: DocumentManagement.PrivilegesForGroup) => {
		if (this.selectedPrivilege.some(item => item.groupId === selectedPrivilege.groupId)) {
			this.selectedPrivilege = this.selectedPrivilege.filter((privilege) => {
				return privilege.groupId !== selectedPrivilege.groupId;
			});
		}
		else {
			let currentSelection = this.selectedPrivilege.filter(item => this.props.documentStore.addedPrivileges.indexOf(item) == -1);
			if (currentSelection.length > 0) {
				this.selectedPrivilege.pop();
			}
			this.selectedPrivilege.push(selectedPrivilege);
		}
	}

	componentDidMount() {
		this.getUnassignedPrivileges();
	}
	/**
	* Get all unassigned privilege for selection
	*/
	getUnassignedPrivileges = () => {
		this.props.documentStore.privilegesWizardStore.isWizardBoxBusy = true;
		let query: DocumentManagement.DocumentPrivilegesQuery = new DocumentManagement.DocumentPrivilegesQuery();
		query.documentId = this.props.documentID;
		query.collectionId = this.props.collectionID;
		DocumentManagement.queryUnassignedDocumentPrivilegeInfosAsync(query).then((result: DocumentManagement.DocumentPrivileges) => {
			this.privilegesForGroups = result.privilegesForGroups.filter(item => !this.props.documentStore.addedPrivileges.some(selectedItem => selectedItem.groupId == item.groupId));
			this.removedPrivilegesForGroups = this.props.documentStore.removedDocumentPrivileges.filter(item => !this.props.documentStore.addedPrivileges.some(selectedItem => selectedItem.groupId == item.groupId));
			this.moveAndSortPrivileges();
			this.props.documentStore.privilegesWizardStore.isWizardBoxBusy = false;
		}).catch((error) => {
			this.props.documentStore.privilegesWizardStore.isWizardBoxBusy = false;
			DialogStore.showError(Strings.general.errorDialogTitle, error);
		});
	}

	/**
	* Search Logic for getting Unassigned Document Privileges
	*/
	search = () => {
		let query: DocumentManagement.DocumentPrivilegesQuery = new DocumentManagement.DocumentPrivilegesQuery();
		query.documentId = this.props.documentID;
		query.collectionId = this.props.collectionID;
		query.searchTerm = this.searchTerm;
		DocumentManagement.queryUnassignedDocumentPrivilegeInfosAsync(query).then((result: DocumentManagement.DocumentPrivileges) => {
			this.privilegesForGroups = result.privilegesForGroups.filter(item => !this.props.documentStore.addedPrivileges.some(selectedItem => selectedItem.groupId == item.groupId));
			this.removedPrivilegesForGroups = this.props.documentStore.removedDocumentPrivileges.filter(item => !this.props.documentStore.addedPrivileges.some(selectedItem => selectedItem.groupId == item.groupId));
			if (query.searchTerm) {
				this.removedPrivilegesForGroups = this.removedPrivilegesForGroups.filter((item) => {
					return item.groupName.toLowerCase().search(query.searchTerm) != -1;
				});
			}
			this.moveAndSortPrivileges();
		}).catch((error) => DialogStore.showError(Strings.general.errorDialogTitle, error));
	}

	moveAndSortPrivileges = () => {
		for (let i = 0; i < this.removedPrivilegesForGroups.length; i++) {
			this.privilegesForGroups.push(this.removedPrivilegesForGroups[i]);
		}
		this.privilegesForGroups = this.privilegesForGroups.sort((a: DocumentManagement.PrivilegesForGroup, b: DocumentManagement.PrivilegesForGroup) => {
			if (a.groupName < b.groupName) return -1;
			if (a.groupName > b.groupName) return 1;
			return 0;
		});
	}

	handleSearchTermChangeFromTypeAhead = (searchTerm: string) => {
		this.searchTerm = searchTerm;
		clearTimeout(this.searchTimeoutHandle);
		this.searchTimeoutHandle = setTimeout(() => this.search(), 300);
	}

	render() {
		return <div className="wizardbox-content">
			<Toolbar>
				<TypeAheadSearchInput showSuggestionList={false} searchTermChangeCallback={this.handleSearchTermChangeFromTypeAhead} />
			</Toolbar>
			<div className="wizardbox-module">
				<div className="list-simple">
					<ul>
						{
							this.privilegesForGroups.map(item => {
								return <DocumentPrivilegesSelectionItem selectedPrivilege={this.selectedPrivilege} onSelectionChange={this.onSelectionPrivilege} key={item.groupId} item={item} documentStore={this.props.documentStore} />;
							})
						}
						{
							//this.removedPrivilegesForGroups.map(item => {
							//	return <DocumentPrivilegesSelectionItem selectedPrivilege={this.selectedPrivilege} onSelectionChange={this.onSelectionPrivilege} key={item.groupId} item={item} documentStore={this.props.documentStore} />;
							//})
						}
					</ul>
				</div>
			</div>
		</div>;
	}
}


interface ICollectionItemProps {
	item: DocumentManagement.PrivilegesForGroup;
	documentStore: DocumentStoreImpl;
	/* pass selected privilege to child component */
	selectedPrivilege: DocumentManagement.PrivilegesForGroup[];
	/* Invoke parent onSelectionPrivilege event */
	onSelectionChange: (selectedPrivilege: DocumentManagement.PrivilegesForGroup) => void;
}

/**
 * Render UnAssigned privileges
 */
@observer
class DocumentPrivilegesSelectionItem extends React.Component<ICollectionItemProps, {}> {

	@action handleClickItem = () => {
		this.props.onSelectionChange(this.props.item);
	}

	render() {
		let selectedPrivilegeClass = this.props.selectedPrivilege.some(item => item.groupId === this.props.item.groupId) ? "is--selection-selected" : "";
		return <li className={selectedPrivilegeClass} onClick={this.handleClickItem}>
			<a>
				<span id={this.props.item.groupId}>
					{this.props.item.groupName}
				</span>
			</a>
		</li>;
	}

}